import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function IndianSocket({ isDownloadMode, downloadAs }) {
  const width = isDownloadMode ? 309 + "px" : getAccuratePixels(309);
  const height = isDownloadMode ? 336 + "px" : getAccuratePixels(336);
  const marginBottom = isDownloadMode ? 15 + "px" : getAccuratePixels(15);

  const isDownloadPng = downloadAs == "icon-png" || downloadAs == "cutout-png";

  if (downloadAs == "icon-png") {
    return null;
  }

  return (
    <div
      className="icon-container"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
          shapeRendering: "geometricPrecision",
          textRendering: "geometricPrecision",
          imageRendering: "optimizeQuality",
          fillRule: "evenodd",
          clipRule: "evenodd",
          width: width,
          height: height,
          marginBottom: marginBottom,
        }}
        viewBox="0 0 152200 165320"
        className={`${isDownloadPng ? "cutout-boundry" : "switch-icon-color"}`}
      >
        <defs>
          <style>
            {/* {".str0{stroke:#2b2a29;stroke-width:1832.03}.fil0{fill:#2b2a29}"} */}
          </style>
        </defs>
        <g>
          <g id="_1974342850096">
            <circle
              cx={131190}
              cy={143931}
              r={20094}
              className="stroke1"
              style={{
                strokeWidth: 1500,
                fill: "none",
              }}
            />
            <ellipse
              cx={76317}
              cy={28187}
              className=" stroke1"
              style={{
                strokeWidth: 1500,
                fill: "none",
              }}
              rx={27271}
              ry={27270}
            />
            <circle
              cx={21011}
              cy={144311}
              r={20094}
              className=" stroke1"
              style={{
                strokeWidth: 1500,
                fill: "none",
              }}
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default IndianSocket;